<template>
  <div class="dialog_wrap"
       v-if="isShow">
    <div class="dialog_content">
      <div class="dialog_message">
        {{cont.message}}
      </div>
      <div class="dialog_btnBox">
        <button class="btn btn_ok"
                @click="btnOk()">
          {{cont.btn.ok}}
        </button>
        <button class="btn btn_cancel"
                @click="btnCancel()">
          {{cont.btn.no}}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      isShow: true,
      cont: {
        message: '',
        btn: {
          ok: '',
          no: ''
        }
      }
    }
  },
  methods: {
    btnOk () { },
    btnCancel () { }
  },
  created () { },
  mounted () { },
  updated () {
  }
}
</script>
<style scoped >
.dialog_wrap {
  position: absolute;
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  min-width: 1166px;
  background: rgba(0, 0, 0, 0.3);
  top: 0;
  left: 200px;
  z-index: 2009;
  line-height: 100%;
}
.dialog_content {
  min-width: 360px;
  min-height: 182px;
  margin: auto;
  background-color: white;
  border: 1px solid #d6d6d6;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  text-align: center;
  position: relative;
}
.dialog_message {
  width: 100%;
  height: 54px;
  display: inline-block;
  line-height: 27px;
  font-size: 14px;
  margin-top: 50px;
}
.dialog_btnBox {
  position: absolute;
  left: 0;
  bottom: 40px;
  width: 100%;
  height: 30px;
  line-height: 30px;
  text-align: center;
}
.btn {
  width: 80px;
  height: 30px;
  border-radius: 4px;
  border: 1px solid green;
  cursor: pointer;
}
.btn_ok {
  background-color: green;
  color: white;
  margin-right: 10px;
}
.btn_cancel {
  background-color: white;
  color: green;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/noticeDialog.vue